import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import ConfirmDialog from './ConfirmDialog';

/**
 * Opens a confirm dialog before logging out. Use requestLogout on button click.
 */
export function useLogoutConfirm() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const requestLogout = useCallback(() => setOpen(true), []);

  const confirmLogout = useCallback(() => {
    logout();
    navigate('/login', { replace: true });
    setOpen(false);
  }, [logout, navigate]);

  const LogoutConfirmDialog = (
    <ConfirmDialog
      open={open}
      onOpenChange={setOpen}
      title="Log out?"
      description="You will need to sign in again to access your account."
      confirmLabel="Log out"
      cancelLabel="Cancel"
      variant="destructive"
      onConfirm={confirmLogout}
    />
  );

  return { requestLogout, LogoutConfirmDialog };
}

export default useLogoutConfirm;
